export default "__VITE_ASSET__Dl_8Z4JU__"